import React from 'react';
import PropTypes from 'prop-types';

import { H2 } from '../containers/Headers';
import Spinner from './Spinner';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const LoadingMessage = ({ title }) => (
  <div className='flex-container center u-full-width mt12-sm mb12-sm'>
    <div>
      <H2>
        <TranslatedCopy id='global.loading' values={{ title }} />
      </H2>
    </div>
    <div style={{ position: 'relative', top: '15px' }}>
      <Spinner />
    </div>
  </div>
);

LoadingMessage.propTypes = {
  title: PropTypes.any.isRequired
};

export default LoadingMessage;
